import { useGameStore } from '@/store/gameStore';
export function GameOverScreen() {
  const score = useGameStore((s) => s.score);
  const highScore = useGameStore((s) => s.highScore);
  const startGame = useGameStore((s) => s.startGame);
  const setScreen = useGameStore((s) => s.setScreen);
  const isNewHighScore = score > 0 && score >= highScore;
  return (
    <div className="flex flex-col items-center justify-center w-full h-full bg-slate-950 select-none">
      <div className="flex flex-col items-center gap-6 px-6 text-center">
        <div className="flex flex-col items-center gap-1">
          <h2 className="text-4xl font-black text-red-400 drop-shadow-[0_0_20px_rgba(255,68,68,0.6)]">
            GAME OVER
          </h2>
          {isNewHighScore && (
            <p className="text-yellow-400 text-sm font-bold tracking-widest uppercase animate-pulse">
              New High Score!
            </p>
          )}
        </div>
        <div className="flex flex-col items-center gap-4">
          <div className="flex flex-col items-center gap-1">
            <p className="text-xs text-slate-500 uppercase tracking-widest">Score</p>
            <p className="text-5xl font-black text-white">{score}</p>
          </div>
          <div className="flex flex-col items-center gap-1">
            <p className="text-xs text-slate-500 uppercase tracking-widest">Best</p>
            <p className="text-2xl font-bold text-yellow-400">{highScore}</p>
          </div>
        </div>
        <div className="flex flex-col gap-3 w-full max-w-[240px]">
          <button
            onClick={startGame}
            className="px-8 py-4 bg-cyan-500 hover:bg-cyan-400 active:scale-95 text-slate-950 font-black text-lg rounded-xl transition-all duration-150 shadow-[0_0_30px_rgba(0,212,255,0.4)]"
          >
            PLAY AGAIN
          </button>
          <button
            onClick={() => setScreen('lobby')}
            className="px-8 py-3 bg-slate-800 hover:bg-slate-700 active:scale-95 text-slate-300 font-bold text-sm rounded-xl transition-all duration-150"
          >
            Main Menu
          </button>
        </div>
      </div>
    </div>
  );
}